import React, { Dispatch, SetStateAction, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import Flex from "../../../../DefaultStyles/Flex";
import { useRecoilValue } from "recoil";
import { faqInputState } from "../../../../../pages/Manage/ManageFaq/ManageFaqDetail";
import FaqCategoryInput from "./ManageFaqDetailInput/FaqCategoryInput";
import FaqSearchInput from "./ManageFaqDetailInput/FaqSearchInput";
import FaqTitleInput from "./ManageFaqDetailInput/FaqTitleInput";
import FaqMemoInput from "./ManageFaqDetailInput/FaqMemoInput";
import FaqTagInput from "./ManageFaqDetailInput/FaqTagInput";
import FaqContentInput from "./ManageFaqDetailInput/FaqContentInput";
import FaqPubicInput from "./ManageFaqDetailInput/FaqPubicInput";
import { OptionType } from "../../../../Filters/DropDown";
import NoticeTopInput from "./ManageFaqDetailInput/NoticeTopInput";
import FaqServiceInput from "./ManageFaqDetailInput/FaqServiceInput";
import FaqServiceSelect from "./ManageFaqDetailInput/FaqServiceSelect";
import FaqPartyStateInput from "./ManageFaqDetailInput/FaqPartyStateInput";
import FaqPartyRoleInput from "./ManageFaqDetailInput/FaqPartyRoleInput";

interface ManageFaqDetailInputProps {
  viewCount: number;
  category: OptionType;
  setCategory: Dispatch<SetStateAction<OptionType>>;
  tag: string;
  setTag: Dispatch<SetStateAction<string>>;
  search: OptionType[] | null;
  setSearch: Dispatch<SetStateAction<OptionType[] | null>>;
  check: {
    public: boolean;
    private: boolean;
    top: boolean;
    normal: boolean;
    hasService: boolean;
    noService: boolean;
  };
  setCheck: Dispatch<
    SetStateAction<{
      public: boolean;
      private: boolean;
      top: boolean;
      normal: boolean;
      hasService: boolean;
      noService: boolean;
    }>
  >;
  memo: string;
  setMemo: Dispatch<SetStateAction<string>>;
  title: string;
  setTitle: Dispatch<SetStateAction<string>>;
  contents: string;
  setContents: Dispatch<SetStateAction<string>>;
  editMode: boolean;
  initContent: string;
  subsId?: OptionType[] | null;
  setSubsId?: Dispatch<SetStateAction<OptionType[] | null>>;
  party?: {
    state: {
      all: boolean;
      before: boolean;
      start: boolean;
      end: boolean;
    };
    role: {
      all: boolean;
      owner: boolean;
      member: boolean;
    };
  };
  setParty?: Dispatch<
    SetStateAction<{
      state: {
        all: boolean;
        before: boolean;
        start: boolean;
        end: boolean;
      };
      role: {
        all: boolean;
        owner: boolean;
        member: boolean;
      };
    }>
  >;
  publicRange?: {
    faq: boolean;
    myparty: boolean;
  };
  setPublicRange?: Dispatch<
    SetStateAction<{
      faq: boolean;
      myparty: boolean;
    }>
  >;
}

export default function ManageFaqDetailInput({
  viewCount,
  category,
  setCategory,
  tag,
  setTag,
  search,
  setSearch,
  check,
  setCheck,
  memo,
  setMemo,
  title,
  setTitle,
  contents,
  setContents,
  editMode,
  initContent,
  subsId,
  setSubsId,
  party,
  setParty,
  publicRange,
  setPublicRange,
}: ManageFaqDetailInputProps) {
  const { pathname } = useLocation();

  const isFaq = Boolean(pathname.includes("faq"));
  const isNotice = Boolean(pathname.includes("notice"));

  const savedContent = useRecoilValue(faqInputState);

  console.log(contents);
  console.log("❤️ savedContent", savedContent);

  console.log(category);

  useEffect(() => {
    if (category?.label === "서비스 이용") {
      setCheck((prev) => ({
        ...prev,
        hasService: true,
        noService: false,
      }));
    }
  }, [category]);

  return (
    <ManageFaqDetailInputContainer>
      {/* 카테고리 */}
      <FaqCategoryInput
        category={category}
        setCategory={setCategory}
        isEditMode={editMode}
        viewCount={viewCount}
      />

      {/* 서비스 지정 */}
      {isFaq && (
        <FaqServiceInput
          check={check}
          setCheck={setCheck}
          isEditMode={editMode}
          resetSubsId={() => setSubsId?.([])}
          category={category}
        />
      )}

      {/* 서비스 선택 */}
      {check.hasService && (
        <FaqServiceSelect
          isEditMode={editMode}
          subsId={subsId!}
          setSubsId={setSubsId!}
        />
      )}

      {/* 공개 여부 */}
      <FaqPubicInput
        check={check}
        setCheck={setCheck}
        isEditMode={editMode}
        publicRange={publicRange}
        setPublicRange={setPublicRange}
      />

      {/* 파티 상태 선택 */}
      {isFaq && (
        <FaqPartyStateInput
          party={party}
          setParty={setParty}
          isEditMode={editMode}
        />
      )}

      {/* 파티 역할 선택 */}
      {isFaq && (
        <FaqPartyRoleInput
          party={party}
          setParty={setParty}
          isEditMode={editMode}
        />
      )}

      {/* 검색어 지정 */}
      {/* {isFaq && (
        <FaqSearchInput
          isEditMode={editMode}
          search={search}
          setSearch={setSearch}
        />
      )} */}

      {/* 관리자 메모 */}
      <FaqMemoInput memo={memo} setMemo={setMemo} isEditMode={editMode} />

      {/* 태그 */}
      {isFaq && <FaqTagInput tag={tag} setTag={setTag} isEditMode={editMode} />}

      {/* 상단 고정 */}
      {isNotice && (
        <NoticeTopInput
          check={check}
          setCheck={setCheck}
          isEditMode={editMode}
        />
      )}

      {/* 제목 */}
      <FaqTitleInput title={title} setTitle={setTitle} isEditMode={editMode} />

      {/* 본문 */}
      <FaqContentInput
        contents={contents}
        setContents={setContents}
        editMode={editMode}
        initContent={initContent}
      />
    </ManageFaqDetailInputContainer>
  );
}

const ManageFaqDetailInputContainer = styled.div`
  width: 100%;
`;

export const FaqDetailRow = styled(Flex)`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.buttonColor.lineNormal};
`;

export const FaqDetailLabel = styled.div`
  width: 148px;
  min-height: 60px;
  display: flex;
  align-items: center;
  padding: 0 10px;

  font-size: 15px;
  font-weight: bold;
  line-height: 22.5px;
  text-align: left;
  color: #858c97;
`;
